import styled from 'styled-components';

import Text from 'components/_core/Text';

export const LoadingMessage = styled(Text)`
  display: block;
  margin-top: ${({ theme }) => theme.spacings.abs48}px;
  align-self: center;
`;
